import { useTheme } from '@mui/material';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import get from 'lodash/get';

const SurveyStarIcon = ({ fill = 'cement.400', ...props }: SvgIconProps) => {
    const theme = useTheme();
    const fillColor = fill.startsWith('#') ? fill : get(theme.palette, fill);

    return (
        <SvgIcon width="39" height="38" viewBox="0 0 39 38" fill="none" {...props}>
            <path
                d="M17.5913 1.84994C18.0717 0.537171 19.9283 0.537173 20.4087 1.84995L24.0072 11.6848C24.2166 12.2573 24.7517 12.6461 25.3609 12.6684L35.8264 13.0516C37.2234 13.1028 37.7971 14.8686 36.697 15.731L28.4555 22.1926C27.9758 22.5687 27.7714 23.1977 27.9384 23.784L30.808 33.8557C31.191 35.2001 29.6889 36.2914 28.5287 35.5117L19.8367 29.6703C19.3307 29.3303 18.6693 29.3303 18.1633 29.6703L9.4713 35.5117C8.31107 36.2914 6.809 35.2001 7.19203 33.8557L10.0616 23.784C10.2286 23.1977 10.0242 22.5687 9.54447 22.1926L1.30297 15.731C0.20288 14.8686 0.776623 13.1028 2.17357 13.0516L12.6391 12.6684C13.2483 12.6461 13.7834 12.2573 13.9928 11.6848L17.5913 1.84994Z"
                fill={fillColor}
            />
        </SvgIcon>
    );
};

export default SurveyStarIcon;
